export default "__VITE_ASSET__CXfSsRlf__"